import type { IntakeFormValues } from './_sections/IntakeFields';
import { findCountryByIso } from './countries';

export type IntakeFormState = IntakeFormValues & {
  prefillIso: string | null;
};

/** Prefill the dial code only when CloudFront sent a country that has a calling code. */
export function buildInitialIntakeValues(
  viewerCountry: string | null | undefined
): IntakeFormState {
  const prefillIso = findCountryByIso(viewerCountry)?.iso2 ?? null;
  return {
    givenName: '',
    familyName: '',
    noFamilyName: false,
    email: '',
    phone: '',
    phoneCountryIso: prefillIso ?? '',
    currentCountryCode: '',
    marketingConsent: false,
    prefillIso,
  };
}
